/**
 * Form step configurations
 */

export const FORM_STEPS = [
  { label: "Personal Information", key: "personalInfo" },
  { label: "Educational Background", key: "educationalBackground" },
  { label: "Professional Experience", key: "professionalExperience" },
  { label: "Fellowship Information", key: "fellowshipInformation" },
  { label: "Recommendations", key: "recommendations" },
  { label: "Additional Information", key: "additionalInformation" },
  { label: "Preview & Submit", key: "preview" },
];

export const STEP_ORDER = [
  "personalInfo",
  "educationalBackground",
  "professionalExperience",
  "recommendations",
  "fellowshipInformation",
  "additionalInformation",
  "preview",
];

export const STEP_KEYS = {
  PERSONAL_INFO: "personalInfo",
  EDUCATIONAL_BACKGROUND: "educationalBackground",
  PROFESSIONAL_EXPERIENCE: "professionalExperience",
  RECOMMENDATIONS: "recommendations",
  FELLOWSHIP_INFORMATION: "fellowshipInformation",
  ADDITIONAL_INFORMATION: "additionalInformation",
  PREVIEW: "preview",
};
